import * as service from './service'
import toast from '@flashex-fe-comp/issdesign/lib/toast'
export default {
  namespace: 'newCashOut',
  state: {
    accountCash: {},
    cardInfo: []
  },
  effects: {
    * getCardInfo ({ payload }, { call, put }) {
      try {
        const res = yield call(service.queryCourierAccountBindInfo, payload)
        const { data } = res
        if (data.status === 200) {
          yield put({
            type: 'save',
            payload: {
              cardInfo: data.data
            }
          })
          return data.data
        } else {
          toast(data.err || data.errMsg || '发生网络错误')
          return Promise.reject()
        }
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * getAccountCash ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getAccountCash, payload)
        const { data } = res
        if (data.code === 200) {
          yield put({
            type: 'save',
            payload: {
              accountCash: JSON.parse(data.data)
            }
          })
          return JSON.parse(data.data)
        } else {
          toast(data.err || data.errMsg || '发生网络错误')
          return Promise.reject()
        }
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * toWithDrawal ({ payload }, { call, put }) {
      try {
        const res = yield call(service.toWithDrawal, payload)
        const { data } = res
        if (data.code !== 200) {
          // toast(data.err || data.errMsg || '发生网络错误')
        }
        return data
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * helpBuyToWithDrawal ({ payload }, { call, put }) {
      try {
        const res = yield call(service.helpBuyToWithDrawal, payload)
        const { data } = res
        if (data.errMsg) {
          toast(data.errMsg)
        }
        return data
      } catch (error) {
        toast('发生网络错误')
      }
    },

    * getCourierApplyWithDraw ({ payload }, { call, put }) {
      try {
        const res = yield call(service.courierApplyWithDraw, payload)
        const { data } = res
        return data
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * aliPayOauthToken ({ payload }, { call, put }) {
      try {
        const res = yield call(service.aliPayOauthToken, payload)
        const { data, status, err, errMsg } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },
    * queryCancelSwitch ({ payload }, { call, put }) {
      try {
        const res = yield call(service.queryCancelSwitch, payload)
        const { data, status, err, errMsg } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },
    * queryWithdrawBankCard ({ payload }, { call, put }) {
      try {
        const res = yield call(service.queryWithdrawBankCard, payload)
        const { data } = res
        if (data.errMsg) {
          toast(data.errMsg)
        }
        return data
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * caculateWithdrawFee ({ payload }, { call, put }) {
      try {
        const res = yield call(service.caculateWithdrawFee, payload)
        const { data } = res
        if (data.errMsg) {
          toast(data.errMsg)
        }
        return data
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * withdrawCount ({ payload }, { call, put }) {
      try {
        const res = yield call(service.withdrawCount, payload)
        const { data } = res
        if (data.errMsg) {
          toast(data.errMsg)
        }
        return data
      } catch (error) {
        toast('发生网络错误')
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
